import Button from '@mui/material/Button';
export default function Store(props) {

    return (
        <div>
            <div style={{ width: '100%', height: '200px', backgroundColor: 'var(--sipzee-yellow-3)', display: 'flex', alignItems: 'center' }}>

                <div style={{ alignSelf: 'center' }}>

                    <div style={{ display: 'flex', flexDirection: 'column', padding: '25px' }}>
                        <div className='Page-Header' style={{ display: 'flex', justifyContent: 'flex-start' }}>
                            <img src='images/StoreIcon.png' style={{ width: '32px', alignSelf: 'center', marginRight: '10px' }} />
                            <div style={{}}>Sipzee Store</div>
                        </div>
                        <div style={{ fontSize: '16pt', display: 'flex', alignSelf: 'center', justifyContent: 'flex-start' }}>
                            We have partnered with Merchology to provide some great Sipzee Merch!
                        </div>
                    </div>
                </div>
            </div>
            <div style={{marginTop:'25px', marginBottom:'25px'} }>
                <Button variant="contained" target='_blank' href="https://sipzee.merchologysolutions.com/">
                    Go to Sizpee Store
                </Button>
            </div>
            <div>
                <img src='images/Store/Merchology.png' style={{ maxWidth: '90vw' }} />
            </div>
           
        </div>
    )
}